<template>

    <div class="container">

        <account-link />

        <div class="my-4">
            <h1>{{ __('Stammdaten') }}</h1>
        </div>

        <div class="row">
            <div class="col-lg-6">

                <form @submit.prevent="form.put(route('account.update', account))">

                    <fieldset>
                        <legend>{{ __('Profil') }}</legend>
                        <text-input :floating="true" label="name" v-model="form.name" :error="form.errors.name" />
                        <text-input type="email" :floating="true" label="email" v-model="form.email" :error="form.errors.email" />
                        <text-input :floating="true" label="customer_number" v-model="form.customer_number" :error="form.errors.customer_number" disabled />

                        <div class="row row-cols-1 row-cols-sm-2">
                            <div class="col">
                                <select-input :floating="true" label="country" v-model="form.country_id" :error="form.errors.country_id">
                                    <option :value="null">{{ __('Please select') }}</option>
                                    <option :value="country.id" v-for="country in countries">{{ country.name }}</option>
                                </select-input>
                            </div>
                            <div class="col"></div>
                            <div class="col w-100">
                                <div class="row">
                                    <div class="col-sm-8">
                                        <text-input :floating="true" label="street" v-model="form.street" :error="form.errors.street" />
                                    </div>
                                    <div class="col-sm-4">
                                        <text-input :floating="true" label="house_number" v-model="form.house_number" :error="form.errors.house_number" />
                                    </div>
                                </div>
                            </div>
                            <div class="col w-100">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <text-input :floating="true" label="zip_code" v-model="form.zip_code" :error="form.errors.zip_code" />
                                    </div>
                                    <div class="col-sm-8">
                                        <text-input :floating="true" label="city" v-model="form.city" :error="form.errors.city" />
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <text-input :floating="true" label="phone" v-model="form.phone" type="tel" :error="form.errors.phone" />
                            </div>
                            <div class="col">
                                <text-input :floating="true" label="fax" v-model="form.fax" type="tel" :error="form.errors.fax" />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset>
                        <legend>{{ __('Sonstiges') }}</legend>
                        <textarea-input :floating="true" label="notes" v-model="form.notes" :error="form.errors.notes" class-name="size-medium" />
                    </fieldset>

                    <submit-button :form="form" />

                </form>

            </div>
        </div>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    import AccountLink from '@/shared/AccountLink';

    export default {
        props: [
            'account',
            'countries',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.account.name,
                    street: this.account.street,
                    house_number: this.account.house_number,
                    customer_number: this.account.customer_number,
                    zip_code: this.account.zip_code,
                    city: this.account.city,
                    country_id: this.account.country_id,
                    phone: this.account.phone,
                    fax: this.account.fax,
                    email: this.account.email,
                    notes: this.account.notes,
                }),
            }
        },
        components: {
            TextInput,
            TextareaInput,
            SelectInput,
            SubmitButton,
            AccountLink,
        },
        watch: {
        },
        methods: {
        },
    }
</script>